import constant from '../constants/panelConstant';

export const panelInitialState = {
    modalPanel: {
        visible: false,
        content: false,
        title: ""
    }
}

export function panelReducer(state, action) {

    switch (action.type) {

        case constant.OPEN_MODAL_PANEL:
            return {
                ...state,
                modalPanel: {
                    visible: true,
                    content: action.payload.content,
                    title: action.payload.title ?? ""
                }
            };
        case constant.CLOSE_MODAL_PANEL:
            return {
                ...state,
                modalPanel: panelInitialState
            };

        default:
            return state;
    }
}

export default panelReducer;
